import React, { useContext, useEffect } from 'react';
import { CursorContent, MousePosition } from '../../store';
import { Wrapper } from './style';

const Cursor = () => {
  const mousePositionDispatch = useContext(MousePosition.Dispatch);
  const { activeType, content } = useContext(CursorContent.State);
  const { mouseX, mouseY } = useContext(MousePosition.State);

  useEffect(() => {
    const handleMouseMove = evt => {
      mousePositionDispatch({
        type: 'set',
        mouseX: evt.clientX,
        mouseY: evt.clientY,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  });

  return activeType ? (
    <Wrapper
      activeType={activeType}
      style={{
        top: mouseY,
        left: mouseX,
      }}
    >
      {content[activeType]}
    </Wrapper>
  ) : null;
};

export default Cursor;
